// Heading scroll-reveal.
//
// IMPORTANT: this uses the GSAP + ScrollTrigger already loaded on the page from
// the CDN (see footer.php). We do NOT bundle our own GSAP here — a second copy
// causes two instances to fight, and ScrollTrigger ends up registered against
// the wrong core, so `scrollTrigger:{...}` is ignored and every tween fires
// immediately on load (the "text already shown before I scroll" bug).
//
// Each `.animate` element fades in + rises. The hero (.block-hero-banner)
// animates once on load (above the fold); everything else reveals on scroll
// into view. Honors prefers-reduced-motion.

(function () {
    var revealAll = function () {
        document.querySelectorAll('.animate').forEach(function (el) {
            el.style.opacity = '1';
            el.style.transform = 'none';
        });
    };

    var start = function () {
        var gsap = window.gsap;
        var ScrollTrigger = window.ScrollTrigger;

        // GSAP missing for any reason — never leave content hidden.
        if (!gsap || !ScrollTrigger) {
            revealAll();
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Hero — animate immediately on load (it's above the fold). The LCP paint
        // is the background video's POSTER (preloaded at high priority), not the
        // heading, so fading the text in here does not delay LCP.
        var heroEls = gsap.utils.toArray('.block-hero-banner .animate');
        if (heroEls.length) {
            if (prefersReduced) {
                gsap.set(heroEls, { opacity: 1, y: 0 });
            } else {
                gsap.to(heroEls, {
                    opacity: 1,
                    y: 0,
                    duration: 0.9,
                    ease: 'power3.out',
                    stagger: 0.15,
                });
            }
        }

        // Everything else — reveal on scroll into view.
        var els = gsap.utils.toArray('.animate').filter(function (el) {
            return !el.closest('.block-hero-banner');
        });

        if (prefersReduced) {
            gsap.set(els, { opacity: 1, y: 0 });
        } else {
            els.forEach(function (el) {
                // Stagger siblings sharing an .animation-wrapper for a cascade.
                var wrapper = el.closest('.animation-wrapper');
                var delay = 0;
                if (wrapper) {
                    var sibs = wrapper.querySelectorAll('.animate');
                    delay = Array.prototype.indexOf.call(sibs, el) * 0.12;
                }

                gsap.to(el, {
                    opacity: 1,
                    y: 0,
                    duration: 0.9,
                    delay: delay,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 85%',
                        once: true,
                    },
                });
            });
        }

        // Recalculate trigger positions once images/fonts settle (lazy images
        // shift layout and can throw off the start positions).
        window.addEventListener('load', function () {
            ScrollTrigger.refresh();
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
